import {
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import {LocationType} from "../../../../commons/types/location.type";
import {TaskType} from "../../../../tasks/types/task.type";
import {TaskPurposeType} from "../../../../commons/types/task-purpose.type";

require('./agent-sequence-score.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-agent-sequence-score',
  templateUrl: './agent-sequence-score.html',
  encapsulation: ViewEncapsulation.Emulated,
})
export class AgentSequenceScoreComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() agentRouteScore: any;

  public viewItems: any[];
  public extraItems: any[];
  public locationTypes: typeof LocationType = LocationType;
  public siteUnit: string;

  @ViewChild('taskContainer') taskContainer!: ElementRef;

  public tasksExtraDataMap: any;

  constructor(@Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef, @Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.siteUnit = this.splitService.getWeightUnit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agentRouteScore && !!this.taskContainer) {
      setTimeout(() => {
        this.initTasksData();
        this.cdr.detectChanges();
      }, 0);
    }
  }

  getBundleIndicationWidth(tasksCount) {
    return 10 + ((tasksCount.toString().length || 0) * 5);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initTasksData();
      this.cdr.detectChanges();

    }, 0);

  }

  private initTasksData() {
    const tasksSequenceData = [];

    this.viewItems = [];
    this.extraItems = [];

    const stopoverPlannedTasksOrder = this.agentRouteScore.plannedTasksOrder.filter((taskId) => {
      const task = this.agentRouteScore.routeTasks.find(t => t.id === taskId);
      if (task.taskType !== TaskType.Internal) {
        return taskId;
      }
    })

    this.agentRouteScore.actualTasksOrder.forEach((taskId, actualTaskIndex) => {
      const taskData: {
        details?: any;
        isCancelled?: boolean;
        isOutOfOrder?: boolean;
        number?: number;
        taskType?: TaskType,
        taskPurpose?: TaskPurposeType
      } = {}

      const task = this.agentRouteScore.routeTasks.find(t => t.id === taskId);
      taskData.details = task;

      taskData.taskType = task.taskType;
      taskData.taskPurpose = task.taskSpec?.purpose || task.purpose

      taskData.isCancelled = this.agentRouteScore.canceledTasks.includes(taskId);

      const plannedTaskIndex = this.agentRouteScore.plannedTasksOrder.findIndex((id) => id === taskId);
      taskData.isOutOfOrder = plannedTaskIndex !== actualTaskIndex;

      taskData.number = stopoverPlannedTasksOrder.findIndex((id) => id === taskId) + 1;

      tasksSequenceData.push(taskData);
    })

    let bundleIndicationSize = 0;
    const containerTotalWidth = (this.taskContainer.nativeElement.offsetWidth * 2) - 16;


    tasksSequenceData.forEach((task, index) => {
      let size = task.details.bundleServiceIdList?.length > 1 ? 50 : 30;


      if (bundleIndicationSize + size < containerTotalWidth) {
        this.viewItems.push(tasksSequenceData[index]);
      } else {

        if (!this.extraItems.length) {
          this.viewItems.splice(index - 1, 1);
          this.extraItems.push(tasksSequenceData[index - 1]);
        }
        this.extraItems.push(tasksSequenceData[index]);
      }
      bundleIndicationSize += size
    })

    if (!!this.extraItems.length) {
      const extraItems = {
        isExtraInfo: true
      }
      this.viewItems.push(extraItems);
    }


    this.tasksExtraDataMap = {};
    if (this.agentRouteScore.routeTasksExtraData) {
      this.agentRouteScore.routeTasksExtraData?.forEach((taskExtraData) => {
        this.tasksExtraDataMap[taskExtraData.taskId] = taskExtraData;
      })
    } else {
      this.agentRouteScore.routeTasks?.forEach((task) => {
        this.tasksExtraDataMap[task.id] = {
          accountReference: task.accountReference,
          packagesExtraData: {
            taskPackagesCount: task.packageCount,
            taskTotalWeight: task.packageWeight
          },
          createdBy: task.createdBy
        };
      })
    }

  }

  protected readonly LocationType = LocationType;
}
